export enum Tenant {
	herzog,
	mk,
}
